package org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.bill_search

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.parseDateStringToMonthModel
import org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.bill_search.components.BillSearchComponent
import org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.bill_search.components.BillSearchSetting
import org.hs_soft.runmynesto.pages.home.sub_page.statistic.mvi.StatisticEvent
import org.hs_soft.runmynesto.pages.home.sub_page.statistic.mvi.StatisticState

@Composable
fun BillSearch(
    windowSizeMode: WindowSizeModeEnum,
    state: StatisticState,
    event:(StatisticEvent)->Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .showContentInOnePage()
//            .fillMaxHeight()

    )
    {
        BillSearchSetting(
            windowSizeMode=windowSizeMode,
            event = event,
            billSearchCalculationLoading = state.billSearchCalculationLoading,
            selectedPeriodType = state.selectedPeriodType,
            showDaysFilterDialog = state.showDaysFilterDialog,
            showFromCalendarFilterDialog = state.showFromCalendarFilterDialog,
            showToCalendarFilterDialog=state.showToCalendarFilterDialog,
            selectedDateFrom = parseDateStringToMonthModel(state.selectedFromDate),
            selectedDateTo = parseDateStringToMonthModel(state.selectedToDate),
            selectedFrom = state.selectedFromDate ?: "",
            selectedTo = state.selectedToDate ?: "",
            selectedCalendarHeaderYear = state.selectedCalendarHeaderYear,
        )

        BillSearchComponent(
            windowSizeMode=windowSizeMode,
            statisticData = state.billSearchStatisticData,
            selectedBillSearchStatisticItem = state.selectedBillSearchStatisticItem,
            onSelectStatisticItem = {
                event(StatisticEvent.OnSelectBillSearchStatisticItem(it))
            },
            searchBillSearchItems = {
                event(StatisticEvent.OnSearchInBillSearchItems(it))
            },
            getBillPdf = {number:String,dateTime:String,cashRegisterId:String->
                event(
                    StatisticEvent.BillPdf(
                        billNumber =number.toInt(),
                        billDate=dateTime,
                        cashRegisterId=cashRegisterId
                    )
                )
            },
            exportStatisticReports = {
                event(
                    StatisticEvent.ExportExcelFile(
                        data = it?: listOf()
                    )
                )
            }
        )

    }

}

